import useLocalStorage from 'hooks/useLocalStorage';
import { createContext, useEffect, useState } from 'react';
import { THEMES } from '../constants';
import axiosInstance from 'utils/axios';
import { baseUrl } from 'utils/constants';
import React from 'react';

interface Settings {
    activeLayout: string;
    direction: string;
    theme: string;
    responsiveFontSizes: boolean;
}

interface AdminConfig {
    [key: string]: string | number | boolean | Record<string, string | number | boolean>;
}

interface SettingsContextValue {
    settings: Settings;
    adminConfig: AdminConfig | null;
    loaded: boolean;
    saveSettings: (updateSettings: Settings) => void;
    checkAndLoadConfig: () => void;
}

const initialSettings: SettingsContextValue = {
    settings: {
        activeLayout: `layout3`,
        direction: `ltr`,
        theme: THEMES.LIGHT,
        responsiveFontSizes: true,
    },
    adminConfig: {},
    loaded: false,
    saveSettings: () => {},
    checkAndLoadConfig: () => {},
};
export const SettingsContext = createContext<SettingsContextValue>(initialSettings); // component props type

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { data: settings, storeData: setStoreSettings } = useLocalStorage<Settings>(`settings`, initialSettings.settings);
    const [adminConfig, setadminConfig] = useState<AdminConfig | null>(null);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const saveSettings = (updateSettings: Settings): void => {
        setStoreSettings(updateSettings);
    };

    const checkAndLoadConfig = (): void => {
        if (localStorage.sid && !loading) {
            loadConfig();
        }
    };

    const loadConfig = (): Promise<void> => {
        setLoading(true);
        return axiosInstance
            .get<AdminConfig>(`${baseUrl}adminconfig`)
            .then(r => r.data)
            .then(setadminConfig)
            .then(() => setLoaded(true));
    };

    useEffect(() => {
        if (localStorage.sid) {
            loadConfig();
        }
    }, []);

    return (
        <SettingsContext.Provider
            value={{
                settings,
                checkAndLoadConfig,
                saveSettings,
                adminConfig,
                loaded,
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsProvider;
